import { Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { WHY_POINTS } from "../../data/site";

export const WhyLaunchX = () => (
  <section id="why" data-testid="why-section" className="py-24 sm:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <SectionHead
            overline="Why LaunchX"
            title="Why Choose LaunchX Academy?"
            sub="Business-focused learning — not tool-only training — in a small, practical classroom batch."
          />
          <Reveal delay={0.2}>
            <div className="mt-9 grid sm:grid-cols-2 gap-x-6 gap-y-3.5">
              {WHY_POINTS.map((w) => (
                <div key={w} data-testid={`why-point-${w.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="flex items-start gap-2.5">
                  <span className="w-5 h-5 rounded-full bg-electric/10 flex items-center justify-center shrink-0 mt-0.5">
                    <Check size={11} strokeWidth={3} className="text-electric" />
                  </span>
                  <span className="text-sm font-medium text-navy leading-snug">{w}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="relative bg-navy rounded-3xl p-8 sm:p-10 overflow-hidden" data-testid="promise-card">
            <div className="absolute inset-0 bg-grid-navy" />
            <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-electric/25 blur-[90px]" />
            <div className="relative">
              <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-cyanx">Our Promise</p>
              <p className="mt-4 font-display font-bold text-white text-xl sm:text-2xl leading-snug">
                LaunchX Academy does not promise guaranteed income, employment or business success.
              </p>
              <p className="mt-4 text-sm text-slate-400 leading-relaxed">
                We provide practical education, tools, frameworks and guided projects that help students understand online business and prepare an execution plan.
              </p>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">
                A student's results depend on their chosen business model, skills, effort, investment, market conditions and quality of execution.
              </p>
              <div className="mt-7 pt-7 border-t border-white/10 grid grid-cols-3 gap-4">
                {[["5", "Business Models"], ["45", "Days Offline"], ["1", "Practical Project"]].map(([v, l]) => (
                  <div key={l}>
                    <p className="font-display font-extrabold text-2xl text-cyanx">{v}</p>
                    <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-slate-500">{l}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
